/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-24 15:16:19
 * @LastEditors: K
 * @LastEditTime: 2022-09-07 16:43:38
 */
import React, { ReactElement } from 'react';
import { Tabs } from 'antd';
import styles from '../regulatoryDataTab.module.css'
import { Zj } from './ZJ/ZJ';

export const RegulatoryPage = (): ReactElement => {
  const { TabPane } = Tabs;
  return (
    <div className={styles.tabWrap}>
      <Tabs defaultActiveKey="0" >
        <TabPane tab="浙江省" key="0">
          <Zj status={0} />
        </TabPane>
        {/* <TabPane tab="湖北省" key="2">
          <Zj />
        </TabPane>
        <TabPane tab="河南省" key="3">
          <Zj />
        </TabPane>
        <TabPane tab="上海省" key="4">
          <Zj />
        </TabPane> */}
      </Tabs>
    </div>
  );
}

